
import React, { useState, useEffect } from "react";
import { ReactFlow, Background, Controls, Node, Edge } from '@xyflow/react';

type FlowChartProps = {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: any;
  onEdgesChange: any;
  onEdgesDelete: any;
  onConnect: any;
  nodeTypes: any;
  onNodeClick?: (event: React.MouseEvent, node: Node) => void;
};

export const FlowChart = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onEdgesDelete,
  onConnect,
  nodeTypes,
  onNodeClick
}: FlowChartProps) => {
  const [fitViewOnInit, setFitViewOnInit] = useState(true);
  
  // Reset fit view whenever nodes or edges change significantly
  useEffect(() => {
    if (nodes.length > 0 || edges.length > 0) {
      setFitViewOnInit(true);
    }
  }, [nodes.length, edges.length]);
  
  return (
    <ReactFlow 
      nodes={nodes} 
      edges={edges} 
      onNodesChange={onNodesChange} 
      onEdgesChange={onEdgesChange} 
      onEdgesDelete={onEdgesDelete} 
      onConnect={onConnect} 
      nodeTypes={nodeTypes} 
      fitView={fitViewOnInit}
      onInit={() => {
        // After first fitting the view, don't automatically fit again
        setTimeout(() => setFitViewOnInit(false), 100);
      }}
      onNodeClick={onNodeClick}
      fitViewOptions={{
        padding: 0.2,
        includeHiddenNodes: false,
        maxZoom: 1.5
      }}
      minZoom={0.1}
      className="bg-secondary"
    >
      <Background />
      <Controls />
    </ReactFlow>
  );
};
